<template>
  <div class="outer-container" :class="getClass">
    <div class="glitch-container" ref="image">
      <img
        v-for="i in imageCopies"
        :key="i"
        class="image"
        :style="imageStyles[i-1]"
        :src="imageSrc"
        :alt="alt"
      />
      <div class="blend-image">
        <img :src="imageSrc" :alt="alt" />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Handles all the glitching effects for a picture
 */
import RandomUtils from "@/scripts/utils/random"
import StoreUtils from "@/scripts/utils/store"
import ImageEffect from "./image-effect-randomizer"
import { mapState } from "vuex"

export default {
  props: {
    closed: Boolean,
    src: String,
    alt: String,
    glitchSrc: String,
    parentGlitch: Boolean
  },
  watch: {
    parentGlitch(newVal) {
      if (newVal) {
        this.glitchMethod()
      } else {
        this.unglitchMethod()
      }
    }
  },
  data() {
    return {
      imageCopies: 3,
      imageStyles: [],
      storeWatch: null
    }
  },
  computed: {
    ...mapState({
      glitch: state => state.projectSynthecite.glitch,
    }),
    // When the screen glitches we want to display the glitched image instead
    imageSrc() {
      return require("@/assets/project-synthecite/" +
        (this.glitch ? this.glitchSrc || this.src : this.src))
    },
    getClass() {
      return this.closed ? "close" : "open"
    }
  },

  methods: {
    /** Glitches the picture several times */
    glitchMethod() {
      this.setGlitchStyle()
    },
    /** Resets picture */
    unglitchMethod() {
      this.imageStyles = []
    },

    /**
     * Sets the style of all picture segments randomly
     */
    setGlitchStyle() {
      let styles = []
      let currentY = 0
      const minOffset = 0
      const maxOffset = 20
      for (let i = 0; i < this.imageCopies; i++) {
        let nextY = 100
        // if we arent at the end find next number
        if (i !== this.imageCopies - 1) {
          nextY = Math.ceil(RandomUtils.RandomNumber(currentY, 100))
        }
        // add clip
        let style = {
          "clip-path": `polygon(0 ${currentY}%, 100% ${currentY}%, 100% ${nextY}%, 0 ${nextY}%)`
        }

        // add random effect
        ImageEffect.RandomEffect(style)

        // move either left or right
        let offset = RandomUtils.RandomNumber(minOffset, maxOffset)
        if (RandomUtils.CoinToss()) {
          offset *= -1
        }
        style.left = `${offset}px`

        // put into string as it doenst work with objects for some reason
        let stringStyle = Object.entries(style).reduce((pre, [k, v]) => {
          return pre + `${k}:${v};`
        }, "")
        styles.push(stringStyle)
        currentY = nextY
      }
      this.imageStyles = styles
    }
  },
  created() {
    // start glitch and watch for glitch
    this.storeWatch = StoreUtils.WatchGlitch(
      this.setGlitchStyle,
      this.unglitchMethod
    )
  },
  beforeDestroy() {
    this.storeWatch()
  }
}
</script>

<style scoped lang="scss">
@import "@/views/project-synthecite/styles/variables.scss";
.outer-container {
  filter: brightness(0.8);
}

.outer-container,
.outer-container * {
  border-radius: 10px;
}
.glitch-container {
  position: relative;
}

.glitch-container .image:first-child {
  position: relative;
}

.glitch-container .image:not(:first-child),
.blend-image {
  position: absolute;
  top: 0;
  left: 0;
}
img {
  display: block;
}
.blend-image {
  background-color: green;
}
.open .blend-image {
  opacity: 0;
  transition: 1.5s opacity;
}
.close .blend-image {
  opacity: 1;
  transition: 0.5s opacity;
}
.image,
.blend-image img {
  width: 100%;
}
.blend-image img {
  mix-blend-mode: multiply;
  display: block;
}
</style>